(self["webpackChunk_dhl_account_app"] = self["webpackChunk_dhl_account_app"] || []).push([[23],{

/***/ 90023:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/en-EU.45318.json";

/***/ })

}])